<template>
  <section class="plan-pay-process h-100">
    <el-steps :active="active" finish-status="success">
      <el-step title=""></el-step>
      <el-step title=""></el-step>
      <el-step title=""></el-step>
      <el-step title=""></el-step>
    </el-steps>

    <section v-if="active === 0">
      <h3 class="h3 font-semi-bold mb-5 text-center">
        Proceso de Pago
      </h3>

      <section class="plan-description-pay mt-4">
        <section class="plan-select-time line-top">
          <h4 class="h4">
            <span class="format-table">{{ getPlanCurrent.description }}</span>
            <span class="float-right"
              ><span class="font-bold"
                >$
                <TopDecimalAmount
                  formatClass="f-h4"
                  :amount="getPlanCurrent.price"/></span
            ></span>
          </h4>
          <h4 class="h4" v-if="getFirma">
            <span class="format-table">Firma electrónica</span>
            <span class="float-right"
              ><span class="font-bold"
                >$
                <TopDecimalAmount
                  formatClass="f-h4"
                  :amount="getPlanCurrent.firma"/></span
            ></span>
          </h4>
          <h4 class="h4" v-if="getMarketingAddon">
            <span class="format-table">Módulo de marketing (WhatsApp)</span>
            <span class="float-right"
              ><span class="font-bold"
                >$
                <TopDecimalAmount
                  formatClass="f-h4"
                  :amount="marketingAddonPriceValue"/></span
            ></span>
          </h4>
        </section>
        <!-- Cupón -->
        <section class="plan-select-coupon line-top">
          <CouponField />
        </section>

        <!-- Descuento aplicado -->
        <section v-if="couponApplied" class="plan-select-discount line-top">
          <p>
            <span class="format-table text-success">
              Descuento ({{ couponValid.discount_preview.description }})
            </span>
            <span class="float-right text-success">
              - $
              <TopDecimalAmount
                formatClass="f-p"
                :amount="couponValid.discount_preview.discount_amount"
              />
            </span>
          </p>
        </section>

        <!-- Licencias de usuario adicionales vigentes: se renuevan con el plan -->
        <section v-if="extraSeats > 0" class="plan-select-seats line-top">
          <p v-if="paymentMethod === 'card'">
            <span class="format-table"
              >Licencias adicionales ({{ extraSeats }} × ${{
                seatUnitPrice.toFixed(2)
              }})</span
            >
            <span class="float-right"
              >$ <TopDecimalAmount formatClass="f-p" :amount="seatsSubtotal"
            /></span>
          </p>
          <p v-else class="text-muted small mb-0">
            Tienes {{ extraSeats }} licencia(s) adicional(es). Con transferencia
            solo se renueva el plan; podrás volver a comprarlas desde Planes.
          </p>
        </section>

        <section class="plan-select-subtotal line-top">
          <p>
            <span class="format-table">Subtotal</span>
            <span class="float-right"
              >$ <TopDecimalAmount formatClass="f-p" :amount="displaySubtotal"
            /></span>
          </p>
          <p>
            <span class="format-table">IVA</span>
            <span class="float-right"
              >$ <TopDecimalAmount formatClass="f-p" :amount="displayIva"
            /></span>
          </p>
        </section>
        <section class="plan-select-total line-top">
          <h3 class="h3 font-semi-bold">
            <span class="format-table">Total</span>
            <span class="float-right"
              >$ <TopDecimalAmount formatClass="f-h3" :amount="displayTotal"
            /></span>
          </h3>
        </section>
      </section>

      <!-- Payment Method Selector -->
      <section class="payment-method-selector mt-4 mb-3">
        <h4 class="h4 font-semi-bold mb-3">Forma de pago</h4>
        <el-radio-group v-model="paymentMethod" class="w-100">
          <div
            class="payment-method-option"
            :class="{
              'payment-method-option--active': paymentMethod === 'card'
            }"
            @click="paymentMethod = 'card'"
          >
            <el-radio label="card" class="m-0">
              <span class="font-semi-bold">Pago con tarjeta</span>
              <span class="text-muted d-block ml-4" style="font-size:13px;"
                >Visa, Mastercard y Diners Club</span
              >
            </el-radio>
          </div>
          <div
            class="payment-method-option mt-2"
            :class="{
              'payment-method-option--active': paymentMethod === 'transfer'
            }"
            @click="paymentMethod = 'transfer'"
          >
            <el-radio label="transfer" class="m-0">
              <span class="font-semi-bold"
                >Transferencia o depósito bancario</span
              >
              <span class="text-muted d-block ml-4" style="font-size:13px;"
                >Deposita y sube tu comprobante</span
              >
            </el-radio>
          </div>
        </el-radio-group>
      </section>
    </section>

    <!-- TRANSFER FLOW: Bank accounts + upload comprobante -->
    <section v-if="active === 1 && paymentMethod === 'transfer'">
      <h3 class="h3 font-semi-bold mb-4 text-break">
        <a href="" class="" @click.prevent="backStep"
          ><i
            class="el-icon-arrow-left font-black mr-4 text-color-black"
          ></i></a
        >Datos bancarios
      </h3>

      <div v-if="bankAccounts.length === 0" class="text-center text-muted py-4">
        <p>No hay cuentas bancarias disponibles. Contacta al administrador.</p>
      </div>

      <div
        v-for="account in bankAccounts"
        :key="account.id"
        class="bank-account-card mb-3 p-3"
        style="border:1px solid #e5e7eb; border-radius:10px; background:#fafafa;"
      >
        <div class="d-flex align-items-center">
          <img
            v-if="account.logo_url"
            :src="account.logo_url"
            :alt="account.bank_name"
            style="width:40px;height:40px;object-fit:contain;border-radius:6px;"
            class="mr-3"
          />
          <div
            v-else
            class="mr-3"
            style="width:40px;height:40px;background:#e5e7eb;border-radius:6px;display:flex;align-items:center;justify-content:center;"
          >
            <i
              class="el-icon-office-building"
              style="font-size:20px;color:#9ca3af;"
            ></i>
          </div>
          <div>
            <p class="font-semi-bold m-0">
              {{ account.bank_name }} &mdash;
              {{ account.account_type === "ahorros" ? "Ahorros" : "Corriente" }}
            </p>
            <p class="m-0 text-muted" style="font-size:13px;">
              Nro: <strong>{{ account.account_number }}</strong>
            </p>
            <p class="m-0 text-muted" style="font-size:13px;">
              Titular: {{ account.holder_name }}
            </p>
            <p class="m-0 text-muted" style="font-size:13px;">
              {{
                account.holder_id && account.holder_id.length === 13
                  ? "RUC"
                  : "CI"
              }}:
              {{ account.holder_id }}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <h4 class="h4 font-semi-bold mb-3">Sube tu comprobante</h4>
        <el-form
          :model="transferForm"
          :rules="transferRules"
          ref="transferForm"
        >
          <b-row>
            <b-col xs="12" sm="6">
              <el-form-item prop="first_name">
                <label class="font-semi-bold m-0">Nombre</label>
                <el-input
                  v-model="transferForm.first_name"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col xs="12" sm="6">
              <el-form-item prop="last_name">
                <label class="font-semi-bold m-0">Apellido</label>
                <el-input
                  v-model="transferForm.last_name"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col xs="12" sm="6">
              <el-form-item prop="customer_ced">
                <label class="font-semi-bold m-0">Cédula / RUC</label>
                <el-input
                  v-model="transferForm.customer_ced"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item prop="comprobante">
            <label class="font-semi-bold m-0"
              >Comprobante de pago
              <span class="text-muted" style="font-size:12px;"
                >(máx. 5MB)</span
              ></label
            >
            <el-upload
              ref="comprobanteUpload"
              class="w-100"
              action=""
              :auto-upload="false"
              :on-change="onComprobanteChange"
              :on-remove="onComprobanteRemove"
              :limit="1"
              accept=".jpg,.jpeg,.png,.pdf"
              drag
            >
              <i
                class="el-icon-upload"
                style="font-size:28px;color:#9ca3af;"
              ></i>
              <div class="el-upload__text" style="font-size:13px;">
                Arrastra o <em>haz clic aquí</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </section>

    <!-- TRANSFER: Confirmation screen -->
    <section v-if="active === 2 && paymentMethod === 'transfer'">
      <div class="text-center py-5">
        <i class="el-icon-time" style="font-size:60px;color:#3ecfb4;"></i>
        <h3 class="h3 font-semi-bold mt-4 mb-2">Tu pago está en revisión</h3>
        <p class="text-muted mb-1">
          Orden: <strong>{{ transferOrderNumber }}</strong>
        </p>
        <p class="text-muted">
          Recibirás una notificación cuando tu pago sea aprobado.
        </p>
        <el-button
          type="primary"
          class="mt-4"
          @click="$router.push({ name: 'plans.history' })"
          >Ver estado de mi suscripción</el-button
        >
      </div>
    </section>

    <!-- CARD FLOW: Original billing form (unchanged) -->
    <section v-if="active === 1 && paymentMethod === 'card'">
      <h3 class="h3 font-semi-bold mb-5 text-break">
        <a href="" class="" @click.prevent="backStep"
          ><i
            class="el-icon-arrow-left font-black mr-4 text-color-black"
          ></i></a
        >Información de Facturación
      </h3>
      <el-form :model="form" :rules="rules" ref="form">
        <b-row>
          <b-col xs="12" sm="6">
            <el-form-item prop="first_name">
              <slot name="label">
                <label class="font-semi-bold m-0">Nombre</label>
              </slot>
              <el-input placeholder="" v-model="form.first_name"></el-input>
            </el-form-item>
          </b-col>
          <b-col xs="12" sm="6">
            <el-form-item prop="last_name">
              <slot name="label">
                <label class="font-semi-bold m-0">Apellido</label>
              </slot>
              <el-input placeholder="" v-model="form.last_name"></el-input>
            </el-form-item>
          </b-col>
        </b-row>
        <!--<b-row>
          <b-col xs="12">
            <el-form-item prop="business_name">
              <slot name="label">
                <label class="font-semi-bold m-0">Nombre Empresa</label>
              </slot>
              <el-input placeholder="" v-model="form.business_name"></el-input>
            </el-form-item>
          </b-col>
        </b-row>-->
        <b-row>
          <b-col xs="12">
            <el-form-item prop="customer_ced">
              <slot name="label">
                <label class="font-semi-bold m-0"
                  >Cédula propietario tarjetahabiente</label
                >
              </slot>
              <el-input placeholder="" v-model="form.customer_ced"></el-input>
            </el-form-item>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12">
            <el-form-item prop="customer_address">
              <slot name="label">
                <label class="font-semi-bold m-0">Dirección</label>
              </slot>
              <el-input
                placeholder=""
                v-model="form.customer_address"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" sm="6">
            <el-form-item prop="country">
              <slot name="label">
                <label class="font-semi-bold m-0">País</label>
              </slot>
              <SelectCountries
                :code="form.customer_country"
                @onChangeSelect="onChangeCountry"
              />
            </el-form-item>
          </b-col>
          <b-col xs="12" sm="6">
            <el-form-item prop="customer_phone">
              <slot name="label">
                <label class="font-semi-bold m-0">Teléfono</label>
              </slot>
              <el-input placeholder="" v-model="form.customer_phone"></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
    </section>
    <section v-if="active === 2"></section>
    <div
      class="text-center"
      v-if="getPlanCurrent.automaticDebit && paymentMethod !== 'transfer'"
    >
      <p>
        <b
          >Activar débito automático {{ isYearlyPlan ? "anual" : "mensual" }}</b
        >
      </p>
      <el-switch
        v-model="automaticDebit"
        active-color="#3fdbbf"
        inactive-color="#989aae"
      >
      </el-switch>
      <p class="mt-3 mb-3">
        Al activar esta opción acepta los
        <label class="font-bold terms-link" @click="showTermsModal = true"
          >términos de cobro recurrente</label
        >
      </p>
    </div>

    <!-- Overlay Términos de cobro recurrente -->
    <transition name="fade">
      <div
        v-if="showTermsModal"
        class="terms-overlay"
        @click.self="showTermsModal = false"
      >
        <div class="terms-modal">
          <div class="terms-modal__header">
            <h4>Términos de cobro recurrente</h4>
            <button class="terms-modal__close" @click="showTermsModal = false">
              &times;
            </button>
          </div>
          <div class="terms-modal__body terms-content">
            <p>
              Al activar el débito automático mensual, usted acepta los
              siguientes términos:
            </p>
            <ol>
              <li>
                <strong>Autorización de cobro:</strong> Autoriza a Mydessk a
                realizar cargos automáticos en su método de pago registrado por
                el monto correspondiente al plan seleccionado, cada mes en la
                fecha de renovación.
              </li>
              <li>
                <strong>Monto y frecuencia:</strong> El cobro se realizará
                mensualmente por el valor del plan vigente más los impuestos
                aplicables (IVA).
              </li>
              <li>
                <strong>Cancelación:</strong> Puede cancelar el débito
                automático en cualquier momento desde su perfil o contactando a
                soporte. La cancelación aplica para el siguiente ciclo de
                facturación.
              </li>
              <li>
                <strong>Fallos de cobro:</strong> Si el cobro no puede
                procesarse, su plan puede ser suspendido temporalmente. Recibirá
                una notificación para actualizar su método de pago.
              </li>
              <li>
                <strong>Cambios de precio:</strong> Cualquier cambio en el
                precio del plan será notificado con al menos 15 días de
                anticipación.
              </li>
              <li>
                <strong>Datos de pago:</strong> Su información de pago es
                procesada de forma segura. Mydessk no almacena datos de tarjeta
                en sus servidores.
              </li>
            </ol>
            <p class="terms-content__footer">
              Para más información, contáctenos en
              <strong>soporte@mydessk.com</strong>
            </p>
          </div>
          <div class="terms-modal__footer">
            <button
              class="btn md__btn-primary px-4"
              @click="showTermsModal = false"
            >
              Entendido
            </button>
          </div>
        </div>
      </div>
    </transition>
    <button
      v-if="
        active !== 2 &&
          !(active === 1 && paymentMethod === 'transfer' && transferOrderNumber)
      "
      type="submit"
      class="btn md__btn-primary px-5 my-4 center"
      name=""
      @click.prevent="nextStep"
      :disabled="transferLoading"
    >
      <span v-if="active === 1 && paymentMethod === 'transfer'">
        <i v-if="transferLoading" class="el-icon-loading mr-2"></i>
        Enviar comprobante
      </span>
      <span v-else> Siguiente <i class="el-icon-arrow-right"></i> </span>
    </button>
  </section>
</template>

<script>
import TopDecimalAmount from "@/components/General/TopDecimalAmount";
import Validate from "@/assets/validate";
import SelectCountries from "@/components/General/SelectCountries";
import payService from "../services/payService";
import CouponField from "./CouponField";

export default {
  name: "PlanPayProcessComponent",
  data() {
    return {
      extraSeats: 0,
      active: 0,
      showTermsModal: false,
      automaticDebit: true,
      firma_electronica: true,
      form: {
        user_business_id: null,
        amount: null,
        pay_details: "",
        first_name: "",
        last_name: "",
        business_name: "",
        customer_country: "EC",
        customer_ced: "",
        customer_address: "",
        customer_phone: "",
        customer_email: ""
      },
      rules: {
        first_name: [Validate.rules.required()],
        last_name: [Validate.rules.required()],
        // business_name: [Validate.rules.required()],
        customer_ced: [Validate.rules.required()],
        customer_address: [Validate.rules.required()],
        customer_phone: [Validate.rules.required()],
        customer_country: [Validate.rules.required()]
      },
      // Transfer payment data
      paymentMethod: "card",
      transferForm: {
        first_name: "",
        last_name: "",
        customer_ced: ""
      },
      transferRules: {
        first_name: [Validate.rules.required()],
        last_name: [Validate.rules.required()],
        customer_ced: [Validate.rules.required()]
      },
      comprobanteFile: null,
      // Debe coincidir con el límite del backend (max:5120 KB en SubscriptionController)
      maxComprobanteSize: 5 * 1024 * 1024,
      transferOrderNumber: null,
      transferLoading: false,

      // Módulo de marketing (WhatsApp) — checkbox por columna de plan
      // (ver NewPlanCard.vue), bundleado en el MISMO cobro. Solo necesitamos
      // el precio acá para mostrar/sumar en el desglose.
      marketingAddonPlan: null
    };
  },
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },

    couponValid() {
      return this.$store.getters.couponValid;
    },

    couponApplied() {
      return this.couponValid && this.couponValid.valid;
    },

    getPlanCurrent() {
      const plan = this.$store.getters.getPlanCurrent;
      if (!plan) return null;

      // If plan already has legacy properties (subTotal, iva, total), return as-is
      if (plan.subTotal !== undefined) return plan;

      // New plan format — compute display values from pricing object
      const billingPeriod = this.$store.getters.billingPeriod || "monthly";
      const pricing = plan.pricing && plan.pricing[billingPeriod];
      const effectivePrice = pricing
        ? pricing.effective_price
        : plan.price || 0;
      const discount = this.couponApplied
        ? this.couponValid.discount_preview.discount_amount
        : 0;
      const discountedPrice = Math.max(effectivePrice - discount, 0);
      const discountedTax = Math.round(discountedPrice * 0.15 * 100) / 100;
      const discountedTotal =
        Math.round((discountedPrice + discountedTax) * 100) / 100;

      const firmaPrice = 24;
      const firmaSubTotal = discountedPrice + firmaPrice;
      const firmaTax = Math.round(firmaSubTotal * 0.15 * 100) / 100;
      const firmaTotal = Math.round((firmaSubTotal + firmaTax) * 100) / 100;

      return {
        ...plan,
        description: plan.display_name || plan.name || plan.description,
        price: effectivePrice,
        subTotal: discountedPrice,
        iva: discountedTax,
        total: discountedTotal,
        firma: firmaPrice,
        subTotalWithFirma: firmaSubTotal,
        ivaWithFirma: firmaTax,
        totalWithFirma: firmaTotal,
        automaticDebit: true
      };
    },
    getPlanTypeSelect() {
      return this.$store.getters.getPlanTypeSelect;
    },
    getFirma() {
      return this.$store.getters.getFirma;
    },
    getMarketingAddon() {
      return this.$store.getters.getMarketingAddon;
    },
    isYearlyPlan() {
      const billingPeriod = this.$store.getters.billingPeriod;
      if (billingPeriod === "annual") return true;
      // Legacy fallback
      const plan = this.$store.getters.getPlanCurrent;
      return plan && (plan.slug || "").includes("-yearly");
    },
    bankAccounts() {
      return this.$store.getters.bankAccounts || [];
    },
    marketingAddonPriceValue() {
      if (!this.marketingAddonPlan) return 0;
      return this.isYearlyPlan
        ? this.marketingAddonPlan.price_annual
        : this.marketingAddonPlan.price_monthly;
    },
    addOnsPrice() {
      const firma = this.getFirma ? 24 : 0;
      const addon = this.getMarketingAddon ? this.marketingAddonPriceValue : 0;
      return firma + addon;
    },
    // Precio de una licencia adicional = licencia principal del plan elegido
    // (sin cupón), igual que lo calcula el backend.
    seatUnitPrice() {
      const plan = this.getPlanCurrent || {};
      const bp = this.$store.getters.billingPeriod || "monthly";
      const effective =
        plan.pricing && plan.pricing[bp] && plan.pricing[bp].effective_price;
      return Number(effective != null ? effective : plan.price || 0);
    },
    seatsSubtotal() {
      if (this.paymentMethod !== "card") return 0;
      return Math.round(this.extraSeats * this.seatUnitPrice * 100) / 100;
    },
    displaySubtotal() {
      return (
        (this.getPlanCurrent.subTotal || 0) +
        this.addOnsPrice +
        this.seatsSubtotal
      );
    },
    displayIva() {
      return Math.round(this.displaySubtotal * 0.15 * 100) / 100;
    },
    displayTotal() {
      return Math.round((this.displaySubtotal + this.displayIva) * 100) / 100;
    }
  },
  methods: {
    async loadExtraSeats() {
      try {
        const { data } = await payService.getSeatsQuote(1);
        this.extraSeats = (data && data.data && data.data.extra_seats) || 0;
      } catch {
        this.extraSeats = 0; // sin plan vigente o ilimitado: nada que renovar
      }
    },
    goPage(name) {
      this.$router.push({ name });
    },
    handleBillingForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          const billingPeriod = this.$store.getters.billingPeriod || "monthly";
          const couponData = this.$store.getters.couponValid;
          const pay = {
            ...this.form,
            user_business_id: this.getUser.user_business.id,
            pay_description:
              this.getPlanCurrent.description ||
              this.getPlanCurrent.display_name ||
              this.getPlanCurrent.name,
            plan_slug: this.getPlanCurrent.slug,
            billing_period: billingPeriod,
            amount:
              this.getPlanCurrent.subTotal ||
              (this.getPlanCurrent.pricing
                ? this.getPlanCurrent.pricing[billingPeriod]?.effective_price
                : 0),
            firma_electronica: this.getFirma,
            marketing_addon: this.getMarketingAddon,
            coupon_code:
              couponData && couponData.valid
                ? this.$store.getters.couponCode
                : null,
            automaticDebit:
              this.getPlanCurrent.automaticDebit && this.automaticDebit,
            // Explícito: lo que se muestra es lo que se cobra.
            extra_seats: this.extraSeats
          };
          try {
            let response = await payService
              .payPpSubscription(pay)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            const { success, data: checkOutPayphone } = response.data;
            if (success) {
              if (checkOutPayphone) {
                location.href = checkOutPayphone;
              } else {
                this.$notifications.error({});
              }
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    nextStep() {
      switch (this.active) {
        case 1:
          if (this.paymentMethod === "transfer") {
            this.handleTransferSubmit();
          } else {
            this.handleBillingForm();
          }
          break;
        case 2:
          break;
        default:
          if (this.paymentMethod === "transfer") {
            this.$store.dispatch("fetchBankAccounts");
          }
          this.active++;
          break;
      }
    },
    backStep() {
      this.active !== 0 && this.active--;
    },
    onChangeCountry(code) {
      this.form.customer_country = code;
    },
    onComprobanteChange(file) {
      if (file.raw.size > this.maxComprobanteSize) {
        this.$notifications.error({
          message: "El comprobante no debe pesar más de 5MB"
        });
        this.$refs.comprobanteUpload.clearFiles();
        this.comprobanteFile = null;
        return;
      }
      this.comprobanteFile = file.raw;
    },
    onComprobanteRemove() {
      this.comprobanteFile = null;
    },
    async loadMarketingAddonPlan() {
      // Best-effort: si falla, el desglose simplemente no suma el addon
      // (el checkbox de NewPlanCard ya decide si getMarketingAddon es true).
      try {
        const { data: planRes } = await payService.getWhatsappAddonPlan();
        if (planRes && planRes.success) this.marketingAddonPlan = planRes.data;
      } catch (e) {
        // silencioso a propósito
      }
    },
    async handleTransferSubmit() {
      this.$refs.transferForm.validate(async valid => {
        if (!valid) return;
        if (!this.comprobanteFile) {
          this.$notifications.error({
            message: "Debes adjuntar el comprobante de pago"
          });
          return;
        }

        this.transferLoading = true;
        this.$store.dispatch("toggleRequestLoading");

        try {
          const billingPeriod = this.$store.getters.billingPeriod || "monthly";
          const couponData = this.$store.getters.couponValid;

          const formData = new FormData();
          formData.append("plan_slug", this.getPlanCurrent.slug);
          formData.append("billing_period", billingPeriod);
          formData.append("first_name", this.transferForm.first_name);
          formData.append("last_name", this.transferForm.last_name);
          formData.append("customer_ced", this.transferForm.customer_ced);
          formData.append("comprobante", this.comprobanteFile);
          formData.append(
            "marketing_addon",
            this.getMarketingAddon ? "1" : "0"
          );
          if (couponData && couponData.valid) {
            formData.append("coupon_code", this.$store.getters.couponCode);
          }

          const res = await payService.payTransfer(formData);
          if (res.data && res.data.success) {
            this.transferOrderNumber = res.data.data.order_number;
            this.active = 2;
          } else {
            this.$notifications.error({
              message: res.data?.message || "Error al enviar el comprobante"
            });
          }
        } catch (e) {
          // El interceptor global (Api.js) ya muestra la notificación
          // adecuada para este error (conexión, validación, servidor, etc.);
          // mostrar aquí un mensaje genérico solo duplicaba el toast.
        } finally {
          this.transferLoading = false;
          this.$store.dispatch("toggleRequestLoading");
        }
      });
    }
  },
  components: {
    TopDecimalAmount,
    SelectCountries,
    CouponField
  },
  mounted() {
    this.loadExtraSeats();
  },
  created() {
    const {
      name: first_name,
      last_name,
      phone: customer_phone,
      email: customer_email
    } = this.getUser;

    this.form = {
      ...this.form,
      first_name,
      last_name,
      customer_phone,
      customer_email
    };

    this.loadMarketingAddonPlan();
  }
};
</script>

<style lang="scss" scoped>
.plan-pay-process {
  height: 100%;
}
.el-steps {
  display: none;
}
.center {
  margin: auto;
  display: block;
}
.borders {
  border-top: solid 1px #e3e3e3;
  border-bottom: solid 1px #e3e3e3;
}
.plan-select-time,
.plan-select-subtotal,
.plan-select-total {
  padding: 1rem 0;
}

.terms-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.terms-modal {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 540px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0efe8;

    h4 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      color: #2d2b55;
    }
  }

  &__close {
    border: none;
    background: none;
    font-size: 22px;
    color: #888;
    cursor: pointer;
    line-height: 1;
    padding: 0 4px;
    &:hover {
      color: #2d2b55;
    }
  }

  &__body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 24px;
  }

  &__footer {
    padding: 16px 24px;
    border-top: 1px solid #f0efe8;
    text-align: right;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
  .terms-modal {
    transition: transform 0.2s;
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .terms-modal {
    transform: scale(0.96);
  }
}

.terms-link {
  color: #3ecfb4;
  cursor: pointer;
  font-weight: 600;
  &:hover {
    color: #1d9e75;
    text-decoration: underline;
  }
}

.terms-content {
  font-size: 14px;
  line-height: 1.7;
  color: #444;

  p {
    margin-bottom: 12px;
  }

  ol {
    padding-left: 20px;
    margin-bottom: 16px;
    li {
      margin-bottom: 10px;
    }
  }

  &__footer {
    margin-top: 16px;
    font-size: 13px;
    color: #888;
  }
}

.plan-select-coupon {
  padding: 0.5rem 0;

  // Integrar el CouponField al estilo del desglose
  :deep(.coupon-field__trigger) {
    text-align: center;
  }

  :deep(.coupon-field__trigger-text) {
    font-size: 13px;
    color: #3ecfb4;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      color: #1d9e75;
    }
  }

  :deep(.coupon-field__form) {
    max-width: 100%;
    margin: 8px 0 0;
  }
}

.plan-select-discount {
  padding: 0.25rem 0;
}

.success-payment {
  flex-direction: column !important;
}

::v-deep .el-upload,
::v-deep .el-upload-dragger {
  width: 100%;
}

.payment-method-option {
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: #3ecfb4;
    background: rgba(62, 207, 180, 0.03);
  }
  &--active {
    border-color: #3ecfb4;
    background: rgba(62, 207, 180, 0.06);
  }
}
</style>
